export const sessionStatuses = [
    {value: 'late_canceled', name: 'Late cancel'},
    {value: 'completed', name: 'Completed'}
];
